module.exports = __webpack_public_path__ + "assets/img/3018.62f76900.svg";